import { createStore, MutationTree, ActionTree, GetterTree } from "vuex";

import i18n from "./modules/i18n";
import auth from "./modules/auth";
import alert from "./modules/alert";
import notice from "./modules/noticePopup";
import localStorage from "./plugins/localStorage";
import outboundParcel from "./service/outbound/outboundParcel";
import outboundQuick from "./service/outbound/outboundQuick";
import outboundComplete from "./service/outbound/outboundComplete";
import outboundRegistry from "./service/outbound/outboundRegistry";
import outboundGlobalMail from "./service/outbound/outboundGlobalMail";
import mypage from "./service/mypage";
import helpFaq from "./service/help/helpFAQ";

export class RootState {}
const Mutations: MutationTree<RootState> = {};
const Actions: ActionTree<RootState, any> = {};
const Getters: GetterTree<RootState, any> = {};
const Modules = {
  i18n,
  auth,
  localStorage,
  alert,
  helpFaq,
  outboundParcel,
  outboundQuick,
  outboundComplete,
  outboundRegistry,
  outboundGlobalMail,
  mypage,
  notice,
};

export default createStore<RootState>({
  state: new RootState(),
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
  modules: Modules,
});
